export const QUERY_MEGA_QUOTAS = 'QUERY_MEGA_QUOTAS';
export const OPEN_QUERY_MEGA_QUOTA_MODAL = 'OPEN_QUERY_MEGA_QUOTA_MODAL';
export const CLOSE_QUERY_MEGA_QUOTA_MODAL = 'CLOSE_QUERY_MEGA_QUOTA_MODAL';
export const RESET_QUERY_MEGA_QUOTA_DATA = 'RESET_QUERY_MEGA_DATA';